export const IMAGE_BASE_PATH = "/assets/images/";
export const VIDEO_BASE_PATH = "/assets/videos/";
export const ICON_BASE_PATH = "/assets/icons/";